<section class="excel-preview">
  @if (sourceEncoding()) {
    <p class="excel-preview__encoding">CSV 編碼：{{ sourceEncoding() }}</p>
  }
  @if (error()) {
    <p class="excel-preview__error">{{ error() }}</p>
  } @else if (sheets().length) {
    <nav class="excel-preview__tabs" aria-label="工作表">
      @for (sheet of sheets(); track sheet.name; let index = $index) {
        <button mat-button type="button" [class.active]="activeSheet() === index" (click)="selectSheet(index)">{{ sheet.name }}</button>
      }
    </nav>
    @if (sheets()[activeSheet()]; as sheet) {
      <ag-grid-angular class="excel-preview__grid" [theme]="theme" [columnDefs]="sheet.columns" [rowData]="sheet.rows" [defaultColDef]="{ suppressHeaderMenuButton: true }" />
    }
  } @else {
    <p>此活頁簿沒有工作表。</p>
  }
</section>
